import type { EnergyRevenuesListResponse } from "../../../RevenueMonitoring.types";

export function averageAvailablePercent(data: EnergyRevenuesListResponse) {
  const dataWithoutNulls = data.filter(
    (item) => item.available_percent !== null
  );
  if (dataWithoutNulls.length === 0) {
    return null;
  }
  const total = dataWithoutNulls.reduce(
    (sum, item) => sum + (item.available_percent ?? 0), // should never be null, but TS needs this
    0
  );
  return total / dataWithoutNulls.length;
}
